import {
  Reg28ActualRegionalExposureMaxLimitsResponseModelMock,
  Reg28ActualRegionalExposureResponseModelMock,
  Reg28ActualRegionalExposureWeightsResponseModelMock
} from '../../../../types/regulation-28/regulation-28.interfaces';
import { ExposureTable } from '../../../../../../components/organisms/exposure-table/ExposureTable';

type ActualRegionalExposureTableProps = {
  tableData: Reg28ActualRegionalExposureResponseModelMock[];
  maxLimits?: Reg28ActualRegionalExposureMaxLimitsResponseModelMock;
  weights?: Reg28ActualRegionalExposureWeightsResponseModelMock;
};

export const Reg28ActualRegionalExposureTable = ({
  tableData,
  maxLimits,
  weights
}: ActualRegionalExposureTableProps) => {
  return (
    <ExposureTable
      columns={[
        {
          displayValue: 'Collective investment funds',
          align: 'left'
        },
        {
          displayValue: '%',
          align: 'right',
          maximumPercentage: maxLimits?.percentage,
          weightedPercentage: weights?.percentage
        },
        {
          displayValue: 'Local %',
          align: 'right',
          maximumPercentage: maxLimits?.local,
          weightedPercentage: weights?.local
        },
        {
          displayValue: 'Foreign %',
          align: 'right',
          maximumPercentage: maxLimits?.foreign,
          weightedPercentage: weights?.foreign
        }
      ]}
      rows={tableData.map((data) => ({
        values: [
          {
            rawValue: data.fundName,
            displayValue: data.fundName,
            align: 'left'
          },
          {
            rawValue: data.percentage ?? 0,
            displayValue: data.percentage?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.local ?? 0,
            displayValue: data.local?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.foreign ?? 0,
            displayValue: data.foreign?.toFixed(2) ?? '-',
            align: 'right'
          }
        ]
      }))}
    />
  );
};
